module.exports = __webpack_public_path__ + "img/img-noimg.f240a8fd.png";